import { Observable } from 'rxjs';
import { StatusTagClass } from './status-tag-class';

export interface StatusTagConfiguration<T = string> {
  status: T;
  class: StatusTagClass;
  icon?: 'tick-circle-duo' | 'time-duo' | 'cross-circle-duo';
  tagText: Observable<string>;
  tooltipClass?: string;
  tooltipText?: Observable<string>;
}
